import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import MinusCircleSvg from '../../assets/icons/minus-circle.svg';
import PlusCircleSvg from '../../assets/icons/plus-circle.svg';
import searchFilter from '../../searchFilter';
import './faq.scss';

const HomeFaq = () => {
    const [a, setA] = React.useState();
    const toggleA = React.useCallback(() => setA((a) => !a), []);
    const [b, setB] = React.useState();
    const toggleB = React.useCallback(() => setB((b) => !b), []);
    const location = useLocation();
    return (
        <div className='faq faq--background-gradient padding-top-2rem mw768-padding-top-3rem'>
            <div className='view'>
                <div className='block'>
                    <div className='padding-left-0-14rem padding-right-0-14rem'>
                        <div className='display-sm semibold color-gray-900 text-align-center'>
                            <FormattedMessage defaultMessage='Frequently asked questions'/>
                        </div>
                        <div className='margin-top-1rem text-lg color-gray-500 text-align-center'>
                            <FormattedMessage defaultMessage='Answers to frequently asked questions can be found on the'/>
                            {' '}
                            <Link className='color-primary-500'to={`/faq${searchFilter(location.search)}`}>F.A.Q</Link>
                            {' '}
                            <FormattedMessage defaultMessage='page' />
                        </div>
                        <div className='margin-top-2rem'>
                            <div className='display-flex justify-content-space-between'>
                                <div>
                                    <div className='text-lg medium color-gray-900'>
                                        <FormattedMessage defaultMessage='How to get a receipt?'/>
                                    </div>
                                    {a &&
                                    <div className='text-md color-gray-500 margin-top-0dot5rem'>
                                        <FormattedMessage defaultMessage='After a successful transaction, we will automatically send you an email with all the details, and you can always use your Ottry personal account.'/>
                                    </div>
                                    }
                                </div>
                                <div className='margin-left-0dot5rem'>
                                    <div className='min-height-1dot75rem display-flex align-items-center'>
                                        <div onClick={toggleA} className='cursor-pointer'>
                                            {a ?
                                                <MinusCircleSvg className='display-block btn-icon--primary height-1dot5rem width-1dot5rem'/>
                                                :
                                                <PlusCircleSvg className='display-block btn-icon--primary height-1dot5rem width-1dot5rem'/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='margin-top-2rem background-color-gray-200 height-0dot0625rem'/>
                        <div className='margin-top-1dot5rem'>
                            <div className='display-flex justify-content-space-between'>
                                <div>
                                    <div className='text-lg medium color-gray-900'>
                                        <FormattedMessage defaultMessage='Can I exchange or return?'/>
                                    </div>
                                    {b &&
                                    <div className='text-md color-gray-500 margin-top-0dot5rem'>
                                        <FormattedMessage defaultMessage='Ottry provides a platform for vendors. Unfortunately, the platform does not currently support automatic returns, and we are already working on implementing this functionality. Therefore for return and exchange, contact the seller immediately using contact details on the sales page.' />
                                        <br/><br/>
                                        <FormattedMessage defaultMessage='With regard to the exchange and return of the seller, sellers must work in accordance with the Law of Ukraine on Consumer Protection, which regulates the conditions of return, the possibility of return, fixes the list of goods not subject to return, and more.' />
                                    </div>
                                    }
                                </div>
                                <div className='margin-left-0dot5rem'>
                                    <div className='min-height-1dot75rem display-flex align-items-center'>
                                        <div onClick={toggleB} className='cursor-pointer'>
                                            {b ?
                                                <MinusCircleSvg className='display-block btn-icon--primary height-1dot5rem width-1dot5rem'/>
                                                :
                                                <PlusCircleSvg className='display-block btn-icon--primary height-1dot5rem width-1dot5rem'/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(HomeFaq);